import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@material-ui/core/styles/withStyles';

import PlanningInfoCardList from './PlanningInfoCardList';
import PlanningLists from './PlanningLists';

class Planning extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        applications: PropTypes.array,
        PlanningCardProps: PropTypes.object
    };

    static defaultProps = {
        PlanningCardProps: {}
    };

    constructor (props) {
        super(props);

        this.state ={
            filter: null
        };

        this.setFilter = this.setFilter.bind(this);
    }

    setFilter (filter) {
        this.setState({
            filter: filter
        });
    }

    render () {
        const { classes, applications, PlanningCardProps } =this.props;
        const { filter } = this.state;

        return (
            <>
                <PlanningInfoCardList
                    applications={applications}
                    onSetFilter={this.setFilter}
                    filter={filter}
                />
                <PlanningLists
                    applications={applications}
                    filter={filter}
                    PlanningCardProps={PlanningCardProps}
                />
            </>
        );
    }
}

const style = theme => ({

});

export default withStyles(style)(Planning);